'use client'

import { formatNumberToNumericalAbreviation } from 'utils/number'

import {
  useFavoriteTotal,
  useIsLoadingFavorites,
} from '@web/app/[locale]/(web)/prod/[slug]/favorites-context'

export function Likes() {
  const isLoading = useIsLoadingFavorites()
  const total = useFavoriteTotal()

  return isLoading ? (
    <span className="bg-cf-dreamy-cloud-500 inline-block size-3 animate-pulse" />
  ) : (
    <span data-testid="stat-likes-value">{formatNumberToNumericalAbreviation(total)}</span>
  )
}
